import $ from 'jquery';
import 'jquery-sticky';

$('[data-custom-sticky]').sticky({topSpacing:56});
